
document.addEventListener("DOMContentLoaded", function () {
  var openBtn = document.getElementById("openFormModal");
  var closeBtn = document.getElementById("closeFormModal");
  var modal = document.getElementById("formModal");

  if (openBtn && closeBtn && modal) {
    openBtn.addEventListener("click", function (e) {
      e.preventDefault();
      modal.style.display = "flex";
    });

    closeBtn.addEventListener("click", function () {
      modal.style.display = "none";
    });

    window.addEventListener("click", function (e) {
      if (e.target === modal) {
        modal.style.display = "none";
      }
    });
  }
});

// COLLECTION BUBBLES -- START

document.addEventListener("DOMContentLoaded", function () {
  new Swiper('.collection_bubble_slider',
    {
      loop:!1,
      grabCursor:!1,
      spaceBetween:12,
      slidesPerGroup:1,
      slidesPerView:"auto",
      watchSlidesProgress:!0,
      draggable:!0,
      autoHeight:!1,
      watchOverflow:!0,
      threshold:10,
      mousewheel:{forceToAxis:!0},
      freeMode:!0,
    }
  )
});

// COLLECTION BUBBLES -- END

// GENERAL PRODUCT POPUP --START

document.addEventListener("DOMContentLoaded", function () {
  var popup = document.getElementById("general_product_popup_div");
  var products = window.general_products || [];
  console.log(products);
  if (!popup || !products.length) return;

  function showRandomProduct() {
    // Pick a random product
    var randomIndex = Math.floor(Math.random() * products.length);
    var productTitle = products[randomIndex]['title'];
    var imageSrc = products[randomIndex]['featured_image'];
    var hrefVal = "/products/" + products[randomIndex]['handle'];
    

    // Set text in div
    //popup.textContent = productTitle;

    document.getElementById("general_product_title").innerHTML = productTitle;
    document.getElementById("general_product_image").src = imageSrc;
    document.getElementById("general_product_href").href = hrefVal;

    // Show div
    popup.style.display = "block";

    setTimeout(() => {
      popup.style.display = "none";
    }, 6000);
  }

  // Run every 4s (2s visible, 2s hidden)
  setInterval(showRandomProduct, 12000);

  // Run first time immediately
  showRandomProduct();
});

// GENERAL PRODUCT POPUP --END